// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"389":"c86a06b9a5c8e5cb","509":"68c88ea72d21419d","1716":"7bc28ec310967d72","5088":"df3d271972035cd0","5840":"63208dc0b5e68943","6224":"d69e5e3e324f3467"}[chunkId] + ".js";
};